import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Timeline from '../components/Timeline';
import JoinTeam from '../components/JoinTeam';
import TeamMembers from '../components/TeamMembers';
import Nerede from '../components/Nerede';
import Neden from '../components/Neden';
import '../styles/components/CombinedSections.scss';

const Home = () => {
    useEffect(() => {
        // Scroll to top when page loads
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="home-page">
            
            <Hero />
            <Neden />
            <div className="combined-sections">
                <JoinTeam />
                <Nerede />
            </div>
            <Timeline />
            <TeamMembers />
        </div>
    );
};

export default Home;